import React from "react";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
import ttAyuda from '../../img/tt_ayuda.png';

export default function LeyendaIntensidades (props) {
    const estiloTabla = {
        border: "solid 1px black", fontWeight: "bold", width:"100%"
    }

    if (props.fontSize) {
        estiloTabla.fontSize = props.fontSize;
    }
    return (
        <table style={estiloTabla}>
            <tbody>
            <tr style={{border: "solid 1px black", backgroundColor:"#CCCCCC", textAlign: "center"}}>
                <td style={{border:"solid 1px black"}}>Intensidad<br/>(EMS-98)</td>
                <td colSpan="2">Descripci&oacute;n</td>
            </tr>

            <FilaLeyenda backgroundColor="rgb(217, 217, 242)" texto="Apenas sentido" 
            titulo="Sentido por muy pocas personas en reposo." 
            intensidad="2"
            mostrarTooltips={props.mostrarTooltips}/>

            <FilaLeyenda backgroundColor="rgb(158, 212, 255)" texto="Sentido levemente" 
            titulo="Sentido por pocas personas. Balanceo de objetos colgantes." 
            intensidad="3"
            mostrarTooltips={props.mostrarTooltips}/>

            <FilaLeyenda backgroundColor="rgb(0, 255, 255)" texto="Sentido ampliamente" 
            titulo="Sentido por muchas personas en el interior de edificaciones y por pocas en el exterior. Las ventanas, puertas y platos vibran."
            intensidad="4"
            mostrarTooltips={props.mostrarTooltips}/>

            <FilaLeyenda backgroundColor="rgb(0, 255, 0)" texto="Sentido fuertemente" 
            titulo="Algunas personas se asustan y corren a la calle. Objetos peque&ntilde;os se desplazan. Vaiven de puertas o ventanas. Leves grietas en casos aislados."
            intensidad="5"
            mostrarTooltips={props.mostrarTooltips}/>
           
            <FilaLeyenda backgroundColor="rgb(255, 255, 0)" texto="Da&ntilde;o leve" 
            titulo="Algunas personas pierden el equilibrio. Algunos objetos caen. Muchas edificaciones presentan da&ntilde;os leves."
            intensidad="6"
            mostrarTooltips={props.mostrarTooltips}/>

            <FilaLeyenda backgroundColor="rgb(255, 170, 0)" texto="Da&ntilde;o moderado" 
            titulo="Los muebles pesados se desplazan. Muchos edificios presentan grietas y caida de revestimiento de los muros."
            intensidad="7"
            mostrarTooltips={props.mostrarTooltips}/>

            <FilaLeyenda backgroundColor="rgb(255, 0, 0)" texto="Da&ntilde;o severo&nbsp;" 
            titulo="Muchas personas tienen dificultad para mantenerse de pie. Caen objetos pesados. Las estructuras antiguas y d&eacute;biles pueden colapsar."
            intensidad="&gt;7"
            mostrarTooltips={props.mostrarTooltips}/>
            </tbody>
        </table>
    );
}

function FilaLeyenda(props) {
    return (
        <tr style={{border: "solid 1px black"}}>
            <td style={{backgroundColor:props.backgroundColor, border:"solid 1px black", 
            textAlign: "center"}}>&nbsp;{props.intensidad}&nbsp;</td>
            <td>{props.texto}</td>
            {props.mostrarTooltips &&
            <td>
                <Tippy content={props.titulo}>
                    <img src={ttAyuda} width="15" height="15" className="tt_leyenda"/>
                </Tippy>
            </td>
            }
        </tr>
    )
}